import PropTypes from 'prop-types';
import cn from 'classnames';
import React, { useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router';
import { useDeepCompareEffect, useUnmount } from 'react-use';

import { productsApi } from '@mssgme/lib';
import PageProduct from '../PageProduct';
import styles from './styles.scss';

export default function PageProductContainer({
    card,
    firstLoad,
    setFirstLoad,
    setLastCollectionSlug,
    lastCollectionSlug,
    ...props
}) {
    const { workspaceId, collections } = card;
    const match = useRouteMatch();
    const { productSlug } = match.params;
    const history = useHistory();
    const [product, setProduct] = useState(false);
    const [isFetching, setIsFetching] = useState(false);
    const defaultCollection = collections.items.find((col) => col.default);
    const [isLoaded, setIsLoaded] = useState(false);
    let unmountTimeout;

    const getProduct = async () => {
        const fromCollection =
            (history.location.state && history.location.state.fromCollection) || defaultCollection._id;

        setIsFetching(true);

        const json = await productsApi.loadBySlug(workspaceId, productSlug, fromCollection);

        setProduct(json);
        setIsFetching(false);
        setIsLoaded(true);
        setFirstLoad(false);
    };

    const unmount = (e, backPath, unmountAll) => {
        e.preventDefault();

        if (unmountAll) {
            setLastCollectionSlug(false);
        }
        setIsLoaded(false);

        unmountTimeout = setTimeout(() => {
            history.push(backPath);
        }, 610);
    };

    useDeepCompareEffect(() => {
        if (defaultCollection) {
            void getProduct();
        }
    }, [productSlug, defaultCollection && defaultCollection._id, card.products]);

    useUnmount(() => {
        clearTimeout(unmountTimeout);
    });

    return (
        <div className={styles.rootContainer}>
            <div className={cn({ [styles.root]: true, [styles.loaded]: isLoaded, [styles.noAnimation]: firstLoad })}>
                {product && (
                    <PageProduct
                        {...props}
                        card={card}
                        product={product}
                        isFetching={isFetching}
                        unmount={unmount}
                        lastCollectionSlug={lastCollectionSlug}
                    />
                )}
            </div>
        </div>
    );
}

PageProductContainer.propTypes = {
    card: PropTypes.object.isRequired,
    firstLoad: PropTypes.bool.isRequired,
    setFirstLoad: PropTypes.func.isRequired,
    setLastCollectionSlug: PropTypes.func.isRequired,
    lastCollectionSlug: PropTypes.any.isRequired,
};
